
/* Mottoli - Đổi ảnh thẻ sản phẩm khi chọn màu */

document.addEventListener('click', function (event) {
  const swatch = event.target.closest(
    '.mottoli-card-swatch'
  );

  if (!swatch) return;

  event.preventDefault();
  event.stopPropagation();

  const card = swatch.closest('.card-wrapper');

  if (!card) return;

  const image = card.querySelector(
    '.card__inner .card__media .media > img'
  );

  const imageUrl = swatch.dataset.mottoliImage;

  if (!image || !imageUrl) return;

  // Xóa srcset cũ để trình duyệt dùng ảnh màu mới.
  image.removeAttribute('srcset');

  // Đổi sang ảnh của biến thể được chọn.
  image.src = imageUrl;

  if (swatch.dataset.mottoliAlt) {
    image.alt = swatch.dataset.mottoliAlt;
  }

  // Cập nhật trạng thái ô màu đang chọn.
  card
    .querySelectorAll('.mottoli-card-swatch')
    .forEach(function (button) {
      button.setAttribute(
        'aria-pressed',
        button === swatch ? 'true' : 'false'
      );
    });

  // Không để ảnh hover phụ che ảnh vừa chọn.
  card.classList.add('mottoli-swatch-selected');
});
